/* unplugin-vue-components disabled */import script from "./ProposalManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalManagement.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__